var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"elevation-0 mx-2",attrs:{"color":"#CC3300","dark":""},on:{"click":_vm.gerarPDF}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" picture_as_pdf ")]),_vm._v(" Gerar PDF ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }